<ng-container *ngIf="dataSource && dataSource?.length">
    <!-- mobile section (it opens a bottom-sheet) -->
    <div class="w-full flex md:hidden justify-between items-center py-2 mb-4 px-4 rounded-lg bg-metal-50" (click)="openBottomSheet()">
        <div class="flex items-center gap-2">
            <img ngSrc="assets/images/ihoplus.svg"  class="bg-white rounded p-2" height="17" width="55" alt="IHO Plus logo">
            <p class="text-base font-semi-bold">خدمات رایگان اختصاصی</p>
        </div>
    
    
        <button
            mat-button
            color="primary"
            class="flex items-center gap-1 text-blue-500 icon-arrow-button -ml-2">
            <span class="text-blue-500 text-sm !font-medium">مشاهده</span>
            <i class="ico-Left text-2xl text-blue-500"></i>
        </button>
    
    </div>
    <!-- desktop section (accordion) -->
    
    <mat-accordion class="filters-sidebar-accordion w-full hidden md:flex flex-col !pt-0 mb-4 !bg-metal-50 !text-black !rounded-lg">
    <!-- *ngFor="let item of dataSource; let first = first; let last = last; let i = index"
    [expanded]="expanded()" class="border-bottom"
    [class]="last ? 'order-1' :'order-10'"
    [class.border-bottom-0.!pb-0]="i === dataSource?.length - 2" -->
        <mat-expansion-panel class="!px-4">
            <mat-expansion-panel-header class="!px-0 !h-12">
                <mat-panel-title>
                <div class="w-full flex justify-between items-center">
                    <div class="flex items-center gap-3">
                        <img ngSrc="assets/images/ihoplus.svg" class="bg-white rounded p-2" height="17" width="55" alt="IHO Plus logo">
                        <p class="text-base font-semi-bold">خدمات رایگان اختصاصی</p>
                    </div>
                </div>
                </mat-panel-title>
            </mat-expansion-panel-header>
    
            <div class="flex flex-col w-full">
                <span class="text-sm text-black-300 mt-2 mb-4 ">خدمات +IHO امکانی جدید از  ایران هتل آنلاین می باشد که با رزرو هتل از این سایت می توانید خدمات زیر را رایگان از "{{hotelName}}" دریافت نمایید. </span>
    
                <div class="grid grid-cols-4 w-full">
                    <div class="flex items-center gap-2" *ngFor="let item of dataSource">
                        <i *ngIf="item?.Icon" class="text-xl {{ item?.Icon }}"></i>
                        <span class="text-sm text-black font-semi-bold">{{ item?.Name }}</span>
                    </div>
                </div>
            </div>
        </mat-expansion-panel>
    </mat-accordion>
</ng-container>
    
    
    <ng-template #bottomSheetTemplate>
        <div class="w-full flex justify-between text-center pt-3">
            <h3 class="text-base font-semi-bold">خدمات رایگان اختصاصی</h3>
            <i class="ico-Close float-right font-bold text-lg"
              (click)="closeBottomSheet()"></i>
        </div>
        <div class="mt-5 flex flex-col gap-4 pb-2">
            <img class="mx-auto" ngSrc="assets/images/ihoplusterkide.png" height="94" width="165" alt="ihoplus icon">
            <span class="flex px-2 py-1 mx-auto bg-blue-50 text-blue-600 font-semi-bold text-sm rounded-lg">رزرو کنید، رایگان هدیه بگیرید</span>
    
            <p class="text-black-200 text-sm font-semi-bold">
                با رزرو اتاق از "{{ hotelName }}" میتوانید خدمات زیر را رایگان از ایران هتل آنلاین دریافت نمایید.
            </p>
    
            <div class="grid grid-cols-2 gap-3 w-full">
                <div class="flex items-center gap-2" *ngFor="let item of dataSource">
                    <i *ngIf="item?.Icon" class="text-xl {{ item?.Icon }}"></i>
                    <span class="text-black text-sm font-semi-bold">{{ item.Name }}</span>
                </div>
            </div>

            <button 
                mat-flat-button
                color="primary"
                (click)="goToRooms()"
                class="w-full !h-11 !text-base !font-bold">
                انتخاب اتاق
            </button>
        </div>
    </ng-template>
